/* eslint-disable */
'use strict';
import Helpers from "../shared/helpers";
const Collection = {
    filtersElements: document.querySelectorAll('.js-filter'),
    url: new URL(window.location.href),
    currentFilters: [],


    /**
     * Init function
     */
    init: function() {
        if (!window.location.pathname.includes('/collections/')) {
            return;
        }
        this.bindFiltersEvents();
        this.updateCurrentFilters();
        this.handleRemoveAllBtn();
    },

    handleRemoveAllBtn() {
        document.querySelector('.js-product-grid__products-remove-all').addEventListener('click', function(e) {
            let url = new URL(window.location.href);

            url.searchParams.getAll('filter.p.m.custom.product_filters').forEach(filter => {
                const filterObj = window.productFilters.find(f => f.id === filter);
                Collection.appendFilter(filter, filterObj.filter_by, filterObj.title, false, true);
            });

            url.searchParams.getAll('filter.p.tag').forEach(filter => {
                Collection.appendFilter(filter, 'filter.p.tag', filter, false, true);
            });
        });
    },

    /**
     * Add filter pills to the DOM
     *
     * @param filter String Filter name used as ID
     */
    addFilterPills: function(filter, filterName, filterBy = '') {
        Collection.toggleRemoveAllBtn(true);
        let html = `
            <div class="product-grid__products-pill" data-filter="${filter}">
                <span class="product-grid__products-pill-title">${filterName}</span>
                <span class="product-grid__products-pill-close js-product-grid__products-pill-close" data-filter="${filter}">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 0.999756L1 8.99976" stroke="#322E22"/>
                        <path d="M9 9.00049L1 1.00049" stroke="#322E22"/>
                    </svg>
                </span>
            </div>
        `;
        // Append pill to the pills container
        document.querySelector('.product-grid__products-pills').insertAdjacentHTML('beforeend', html);

        // Add event listener to close button
        document.querySelector(`.js-product-grid__products-pill-close[data-filter="${filter}"]`).addEventListener('click', function(e) {
            Collection.appendFilter(filter, filterBy, filterName, false, true);
            Collection.removeFilterPills(filter);
        });
    },

    /**
     * Toggle remove all button
     *
     * @param flag Boolean Flag to toggle the remove all button
     */
    toggleRemoveAllBtn: function(flag) {
        if (flag) {
            document.querySelector('.js-product-grid__products-remove-all').classList.remove('is-hidden');
            let mobileRemoveBtn = document.querySelector('.product-grid__products-remove-all--mobile')
            if(mobileRemoveBtn) {
                document.querySelector('.product-grid__products-remove-all--mobile').classList.remove('is-hidden')    
            }                    
        } else {
            let mobileRemoveBtn = document.querySelector('.product-grid__products-remove-all--mobile')
            if(mobileRemoveBtn) {
                document.querySelector('.product-grid__products-remove-all--mobile').classList.add('is-hidden')    
            }      
            document.querySelector('.js-product-grid__products-remove-all').classList.add('is-hidden');
        }
    },

    /**
     * Remove filter pills from the DOM
     *
     * @param filter String Filter name used as ID
     */
    removeFilterPills: function(filter) {
        const pillElement = document.querySelector(`.product-grid__products-pill[data-filter="${filter}"]`);
        if (pillElement) {
            pillElement.remove();
        }
    },

    /**
     * Toggle filter checkbox
     *
     * @param filter String Filter name used as ID
     */
    toggleFilterCheckbox: function(filter) {
        let checkbox = document.querySelector(`input[data-filter="${filter}"]`);
        checkbox.checked = !checkbox.checked;
    },


    /**
     * Update current filters from the URL
     */
    updateCurrentFilters: function() {
        let url = new URL(window.location.href)
        let urlSearchParams = url.searchParams;
        urlSearchParams.getAll('filter.p.tag').forEach(filter => {
            if (!Collection.currentFilters.includes({filterBy: 'filter.p.tag', filter: filter})) {
                Collection.currentFilters.push({filterBy: 'filter.p.tag', filter: filter});
                Collection.addFilterPills(filter, filter, 'filter.p.tag');
                Collection.toggleFilterCheckbox(filter);
            }
        });

        urlSearchParams.getAll('filter.p.m.custom.product_filters').forEach(filter => {
            if (!Collection.currentFilters.includes({filterBy: 'filter.p.m.custom.product_filters', filter: filter})) {
                let productFilter = window.productFilters.find(f => f.id === filter);
                Collection.currentFilters.push({filterBy: 'filter.p.m.custom.product_filters', filter: filter});
                Collection.addFilterPills(filter, productFilter.title, 'filter.p.m.custom.product_filters');
                Collection.toggleFilterCheckbox(filter);
            }
        });
    },


    /**
     * Bind filter events
     */
    bindFiltersEvents: function() {
        this.filtersElements.forEach(el => {
            el.addEventListener('click', function(e) {
                const parentElement = e.target.closest('li');
                const filterBy = parentElement.dataset.filterBy;
                const filter = parentElement.dataset.filter;
                const filterName = parentElement.dataset.filterName;
                Collection.appendFilter(filter, filterBy, filterName);
            });
        });

        document.querySelector('.js-sort-by').addEventListener('change', function(e) {
            let url = new URL(window.location.href);
            url.searchParams.set('sort_by', e.target.value);
            window.history.pushState({ path: url.toString() }, '', url.toString());
            Collection.updateProducts();
        });
    },


    /**
     * Append filter to the current filters array
     *
     * @param filter String Filter name used as ID
     */
    appendFilter: function(filter, filterBy, filterName, sort_by = false, triggerCheckbox = false) {
        let data = {
            filterBy: filterBy,
            filter: filter
        }

        // If the filter is already present, remove it
        if (sort_by) {
            if (Collection.currentFilters.some(e => e.filter === filter)) {
                Collection.currentFilters.splice(Collection.currentFilters.indexOf(Collection.currentFilters.find(e => e.filter === filter)), 1);
            }
            Collection.currentFilters.push(data);
        } else {
            if (Collection.currentFilters.find(e => e.filter === filter)) {
                Collection.currentFilters.splice(Collection.currentFilters.indexOf(Collection.currentFilters.find(e => e.filter === filter)), 1);
                Collection.removeFilterPills(filter);
            } else {
                // Otherwise, add the new filter
                Collection.currentFilters.push(data);
                Collection.addFilterPills(filter, filterName, filterBy);
            }
        }
        

        if (!sort_by && triggerCheckbox) {
            Collection.toggleFilterCheckbox(filter);
        }


        // URL Object Init
        let url = new URL(window.location.href)


        // Remove all filters from the search params
        url.searchParams.delete('filter.p.m.custom.product_filters');
        url.searchParams.delete('filter.p.tag');

        if (Collection.currentFilters.length < 1) {
            Collection.toggleRemoveAllBtn();
        }

        
        // Update the search params with the new filter array
        if (Collection.currentFilters.length > 0) {
            Collection.currentFilters.forEach(f => {
                if (sort_by) {
                    url.searchParams.set(f.filterBy, f.filter);
                } else {
                    url.searchParams.append(f.filterBy, f.filter);
                }
            });
        } else {
             // Remove all filters from the search params
             url.searchParams.forEach(function(value, key) {
                if (key !== 'sort_by') {
                    url.searchParams.delete(key);
                }
            });
        }
        const newUrl = url.toString();
        window.history.pushState({ path: newUrl }, '', newUrl);

        Collection.updateProducts();
    },


    /**
     * Update products
     */
    updateProducts: function () {
        // Assuming you have an element with id "targetElement" where you want to load the content
        var targetElement = document.querySelector('.product-grid__products-bottom');

        // Make a fetch request to fetch the content from the server
        fetch(window.location)
            .then(response => {
                // Extract the HTML content from the response
                return response.text();
            })
            .then(html => {
                // Create a temporary div element
                var tempDiv = document.createElement('div');
                // Set the innerHTML of the tempDiv with the fetched HTML content
                tempDiv.innerHTML = html;

                // Extract the specific element(s) you need
                var specificElement = tempDiv.querySelector('.product-grid__products-bottom');

                // Check if the specific element is found
                if (specificElement) {
                    // Clear the targetElement
                    targetElement.innerHTML = '';
                    // Append the specific element to the targetElement
                    targetElement.insertAdjacentHTML('afterbegin', specificElement.innerHTML);
                }
                Helpers.quickModalPopup();
                //Helpers.quickModalActions();
            })
    }
};

export default Collection;